import * as angular from 'angular';
import 'angular-ui-router';
import './Tenant.scss';
import { CreatSuccessController } from './CreateSuccess/CreateSuccessController';
import CreateSuccessView from './CreateSuccess/CreateSuccessView.html';
import TenantNotFoundView from './notFound/TenantNotFoundView.html';
import TenantInvitationRequestSentView from './invitationRequestSent/TenantInvitationRequestSentView.html';
import { ExistingTenantController } from './existingTenant/ExistingTenantController';
import ExistingTenantView from './existingTenant/ExistingTenantView.html';
import TenantPanelView from './panel/TenantPanelView.html';
import { BrowserCanvasComponent } from './browserCanvas/browserCanvas.component';
import { CardHintComponent } from './cardHint/cardHint.component';
import { TenantService } from './TenantService';
import { UrlTenantHandlerService } from './UrlTenantHandlerService';
import { TenantNotFoundController } from './notFound/TenantNotFoundController';
import { TenantInvitationRequestSentController } from './invitationRequestSent/TenantInvitationRequestSentController';
import { TenantPanelController } from './panel/TenantPanelController';
import { welcomeScreenStateName } from 'modules/account';
import { BlipToastService } from 'modules/shared/BlipToastService';
import { InviteMemberController } from './inviteMember/InviteMemberController';
import { CreationErrorController } from './personal/CreationErrorController';
import CreationErrorView from './personal/CreationErrorView.html';
import InviteMemberView from './inviteMember/InviteMemberView.html';
import { CreateTenantController } from './create/CreateTenantController';
import CreateTenantView from './create/CreateTenantView.html';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { portalFragmentPermissionGroupsScriptSource } from 'app.constants';
import { PermissionGroupsController } from './permissionGroups/PermissionGroupsController';
import PermissionGroupsView from './permissionGroups/PermissionGroupsView.html';
import { applicationListStateName } from 'modules/application/list';
import { PermissionGroupsFeatures } from './permissionGroups/PermissionGroupsFeatures';
export const createTenantStateName = 'auth.application.tenantCreate';
export const tenantStateName = 'auth.application.tenant';
export const existingTenantStateName = 'auth.application.tenantExisiting';
export const tenantInvitationRequestSentStateName = 'auth.application.tenantInvitationRequestSent';
export const createTenantSuccessStateName = 'auth.application.tenantCreateSuccess';
export const tenantNotFoundStateName = 'auth.application.tenantNotFound';
export const inviteMemberTenantName = 'auth.application.tenantInviteMember';
export const personalTenantCreationError = 'auth.application.tenantPersonalCreationError';
export const tenantPermissionGroups = 'auth.application.tenantPermissionGroups';
export const tenantPermissionGroupsBase = 'auth.application.tenantPermissionGroupsBase';
export const tenantModule = angular
    .module('tenant', ['ui.router'])
    .service('TenantService', TenantService)
    .service('UrlTenantHandlerService', UrlTenantHandlerService)
    .service('BlipToastService', BlipToastService)
    .component('browserCanvas', BrowserCanvasComponent)
    .component('cardHint', CardHintComponent)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state(createTenantStateName, {
            url: '/application/tenant/create?id&name',
            views: {
                '@': {
                    controller: CreateTenantController,
                    controllerAs: '$ctrl',
                    template: CreateTenantView,
                },
            },
        })
            .state(createTenantSuccessStateName, {
            url: '/application/tenant/create-success?id&name',
            views: {
                '@': {
                    controller: CreatSuccessController,
                    controllerAs: '$ctrl',
                    template: CreateSuccessView,
                },
            },
            params: {
                invitationsSent: undefined,
            },
        })
            .state(existingTenantStateName, {
            url: '/application/tenant/existing?id&name',
            views: {
                '@': {
                    controller: ExistingTenantController,
                    controllerAs: '$ctrl',
                    template: ExistingTenantView,
                },
            },
        })
            .state(tenantNotFoundStateName, {
            url: '/application/tenant/not-found',
            views: {
                '@': {
                    controller: TenantNotFoundController,
                    controllerAs: '$ctrl',
                    template: TenantNotFoundView,
                },
            },
        })
            .state(tenantInvitationRequestSentStateName, {
            url: '/application/tenant/invitation-request-sent?id&name',
            views: {
                '@': {
                    controller: TenantInvitationRequestSentController,
                    controllerAs: '$ctrl',
                    template: TenantInvitationRequestSentView,
                },
            },
        })
            .state(inviteMemberTenantName, {
            url: '/application/tenant/inviteMember?tenantId&tenantName',
            views: {
                '@': {
                    controller: InviteMemberController,
                    controllerAs: '$ctrl',
                    template: InviteMemberView,
                },
            },
        })
            .state(tenantPermissionGroupsBase, {
            url: '/application/tenant/permission-groups',
            views: {
                '@auth.application': {
                    controller: PermissionGroupsController,
                    controllerAs: '$ctrl',
                    template: PermissionGroupsView,
                },
            },
            resolve: {
                authorization: fetchPermissionGroupsPermission,
            },
            onEnter: () => {
                return MicroFrontendService.addSource(portalFragmentPermissionGroupsScriptSource);
            },
        })
            .state(tenantPermissionGroups, {
            url: '/application/tenant/permission-groups/{path:any}',
            views: {
                '@auth.application': {
                    controller: PermissionGroupsController,
                    controllerAs: '$ctrl',
                    template: PermissionGroupsView,
                },
            },
            resolve: {
                authorization: fetchPermissionGroupsPermission,
            },
            onEnter: () => {
                return MicroFrontendService.addSource(portalFragmentPermissionGroupsScriptSource);
            },
        })
            .state(tenantStateName, {
            url: '/application/tenant/{path:any}',
            views: {
                '@auth.application': {
                    controller: TenantPanelController,
                    controllerAs: '$ctrl',
                    template: TenantPanelView,
                },
            },
            data: {
                hasOwnFooter: true,
            },
        })
            .state(personalTenantCreationError, {
            url: '/application/tenant/personal/creationError',
            views: {
                '@auth.application': {
                    controller: CreationErrorController,
                    controllerAs: '$ctrl',
                    template: CreationErrorView,
                },
            },
        });
    }])
    .run(['$rootScope', 'TenantService', '$state', 'AccountService2',
    function ($rootScope, TenantService, $state, AccountService2) {
        $rootScope.$on('$stateChangeStart', async (_, toState, toParams) => {
            const isAnon = toState.name.startsWith('anon');
            if (isAnon) {
                return;
            }
            const userHasTenant = await TenantService.isOrganizationEnabled();
            if (!userHasTenant) {
                try {
                    const permittedStates = [welcomeScreenStateName];
                    const blipAccount = await AccountService2.me();
                    if (blipAccount?.extras?.isOldUser != 'true' &&
                        !toState.name?.startsWith(tenantStateName) &&
                        !permittedStates.includes(toState.name)) {
                        const invitedTenant = toParams['tenant-invitation'];
                        $state.go(welcomeScreenStateName, { ['tenant-invitation']: invitedTenant });
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
        });
    },
]).name;
const fetchPermissionGroupsPermission = async ($state, InitializeUserService, AccountService2, TenantService) => {
    await AccountService2.waitForInitialization();
    await InitializeUserService.initFeatureToggle();
    const isEnabled = await PermissionGroupsFeatures.isPermissionGroupsEnabled();
    const user = AccountService2.meSync ? AccountService2.meSync() : await AccountService2.me();
    const identity = user?.identity || user?.email;
    const isContractAdmin = identity ? await TenantService.isContractAdmin(identity) : false;
    if (!isEnabled || !isContractAdmin) {
        $state.go(applicationListStateName);
    }
};
